<template>
    <b-modal ref="mdlNuovaVoce" size="lg" :title="titoloModal" @hidden="onCloseModal" @ok="onClickOk" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div>
            <b-card class="sa-card" header="Dettaglio" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Codice:</label>
                        <b-form-input v-model="jsonData.codice" placeholder="Codice"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione:</label>
                        <b-form-input v-model="jsonData.descrizione" placeholder="Descrizione"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <b-form-checkbox v-if="!nuovo" v-model="jsonData.attivo" name="check-button" switch>
                            <label class="sa-label-data">Attivo</label>
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card" header="Sottocategorie" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaSottocategorie" :fields="fields" :current-page="1" :per-page="1000000000" sort-icon-left head-variant="light">
                            <template #cell(index)="row">
                                {{ row.index + 1 }}
                            </template>
                            <template #cell(codice)="item">
                                <span v-if="item.index !== jsonData.listaSottocategorie.length - 1">{{ item.item.codice }}</span>
                                <b-form-input v-if="item.index === jsonData.listaSottocategorie.length - 1" v-model="item.item.codice" placeholder="Codice"></b-form-input>
                            </template>
                            <template #cell(descrizione)="item">
                                <span v-if="item.index !== jsonData.listaSottocategorie.length - 1">{{ item.item.descrizione }}</span>
                                <b-form-input v-if="item.index === jsonData.listaSottocategorie.length - 1" v-model="item.item.descrizione" placeholder="Descrizione"></b-form-input>
                            </template>
                            <template v-slot:cell(attivo)="{ item }">
                                <b-form-checkbox v-if="!nuovo" v-model="item.attivo" name="check-button" switch></b-form-checkbox>
                            </template>
                            <template #cell(actions)="row">
                                <b-button v-if="row.index === jsonData.listaSottocategorie.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAdd(jsonData.listaSottocategorie, row.item)">
                                    <b-icon icon="plus"></b-icon>
                                </b-button>
                                <b-button v-if="row.index !== jsonData.listaSottocategorie.length - 1" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelete(jsonData.listaSottocategorie, row)">
                                    <b-icon icon="trash"></b-icon>
                                </b-button>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-card>
            <modal-error ref="cmpModalError"></modal-error>
        </div>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";
export default {
    components: { ModalError },
    mixins: [UtilityMixin],
    // components: { DatePicker },
    data() {
        return {
            isNew: true,
            isReadonly: false,
            isRequired: false,
            nuovo: true,
            id: null,
            pathResource: "/categorie",
            pathResourceSezioneDizionario: "/dizionariosezioni",
            titoloModal: "",
            sezioneOptions: [{ value: "", text: "-Seleziona Valore-" }],
            jsonData: { codice: null, descrizione: null, attivo: true, listaSottocategorie: [] },
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Codice",
                    key: "codice",
                    thStyle: "width: 20rem",
                    // sortable: true,
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                    // thStyle: "width: 20rem",
                    // sortable: true,
                },
                {
                    label: "Attivo",
                    key: "attivo",
                    thStyle: "width: 5rem",
                    // sortable: true,
                },
                {
                    label: "Attivo",
                    key: "attivo",
                    thStyle: "width: 7rem",
                    sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", thStyle: "width: 5rem" },
            ],
        };
    },
    methods: {
        openModal(value) {
            let me = this;
            me.$emit("beforloadData");
            if (value !== null) {
                me.titoloModal = "Modifica Categoria";
                me.id = value;
                me.loadDataCategoria();
                me.nuovo = false;
            } else {
                me.titoloModal = "Aggiungi Categoria";
                me.nuovo = true;
                me.jsonData = { codice: null, descrizione: null, attivo: true, listaSottocategorie: [{ codice: null, descrizione: null, attivo: true }] };
            }

            // console.log(me.jsonData);

            me.$refs.mdlNuovaVoce.show();
            me.$emit("afterLoadData");
        },
        onCloseModal() {
            let me = this;
            me.$emit("beforloadData");
            me.jsonData = { codice: null, descrizione: null, attivo: true, listaSottocategorie: [{ codice: null, descrizione: null, attivo: true }] };
            me.$emit("afterLoadData");
        },
        onClickOk(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("afterSaveSuccess", response);
            me.$emit("afterLoadData");
            me.$refs.mdlNuovaVoce.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
            this.$emit("afterLoadData");
        },
        loadDataCategoria() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + this.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.$emit("afterLoadData");
            me.jsonData.listaSottocategorie.push({ codice: null, descrizione: null, attivo: true });
        },
        loadDataError(response) {
            console.log(response);
            this.$emit("afterLoadData");
        },
        onAdd(array, value) {
            if (value.codice) {
                array.push({ codice: null, descrizione: null, attivo: true });
            } else {
                this.$bvModal
                    .msgBoxOk("Il campo Codice e' OBBLIGATORIO", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then(() => {
                        // console.log(value);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onDelete(array, row) {
            if (row.index != array.length) {
                this.$bvModal
                    .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                        title: "Titolo",
                        buttonSize: "sm",
                        okVariant: "secondary",
                        cancelVariant: "danger",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            array.splice(row.index, 1);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
};
</script>
